app.controller('CIF3-CTRL', ['$scope', '$window', '$uibModal', '$q', 'deviceDetector', '$filter', '$http', '$timeout',
    function ($scope, $window, $uibModal, $q, deviceDetector, $filter, $http, $timeout) {

        //--------------------------------------------Setting Upload-------------------------------------------- 
        $scope.device = deviceDetector;
        $scope.isMobile = $scope.device.isMobile();

        $scope.filenameNPWP = "";
        $scope.fileNPWP = "";
        $scope.fileNPWPext = "";
        $scope.NPWPile = [];

        $scope.filenameOthers = "";
        $scope.fileOthers = "";
        $scope.fileOthersext = "";
        $scope.OthersFile = [];

        $scope.filenameParent = "";
        $scope.fileParent = "";
        $scope.fileParentext = "";
        $scope.ParentFile = [];

        $scope.disabledNPWPNumber = false;

        $scope.openCamera = function (tipe) {
            console.log('bala', tipe);
            let message = tipe;
            let url = 'ModalCamera.html';
            let ctrl = 'CameraController';


            if ($scope.device.isMobile()) {
                //url = 'ModalBrowse.html';
                //ctrl = 'BrowseController';
                //$scope.append = 'data:image/png;base64,';
            }

            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: url,
                controller: ctrl,
                size: 'md',
                resolve: {
                    items: function () {
                        return message;
                    }
                }
            });
            modalInstance.result.then(function (resolvedResponse) {
                //console.log('ktp',resolvedResponse);
                if (resolvedResponse) {
                    if (tipe == "KTP")
                        $scope.ktpPhoto = resolvedResponse;
                    else if (tipe == "NPWP")
                        $scope.npwpPhoto = resolvedResponse;
                    else if (tipe == "SELFIE")
                        $scope.selfiePhoto = resolvedResponse;
                    else if (tipe == "OTHERS")
                        $scope.othersPhoto = resolvedResponse;
                    else if (tipe == "PARENT")
                        $scope.parentPhoto = resolvedResponse;
                    else
                        $scope.ttdPhoto = resolvedResponse;
                }
            }, function () { });
        };

        $scope.remove = function (tipe) {
            if (tipe == "KTP")
                $scope.ktpPhoto = '';
            else if (tipe == "SELFIE")
                $scope.selfiePhoto = '';
            else if (tipe == "NPWP")
                $scope.npwpPhoto = '';
            else if (tipe == "OTHERS")
                $scope.othersPhoto = '';
            else if (tipe == "PARENT")
                $scope.parentPhoto = '';
            else
                $scope.ttdPhoto = '';
        };

        $scope.selectNPWP = function (files) {

            $scope.NPWPFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {

                if (allowed)
                    $scope.fileNPWP = btoa(e.target.result.toString());
            };

            reader.readAsBinaryString(files[0]);
            $scope.fileNPWPext = files[0].name.substr(files[0].name.lastIndexOf('.'));

            if ($scope.allowedExt.indexOf($scope.fileNPWPext.toLowerCase()) < 0) {

                allowed = false;
                $scope.fileNPWPext = '';
                $scope.NPWPFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            } else {

                $scope.filenameNPWP = files[0].name;
            }
        };

        $scope.selectParent = function (files) {

            $scope.ParentFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {

                if (allowed)
                    $scope.fileParent = btoa(e.target.result.toString());
            };

            reader.readAsBinaryString(files[0]);
            $scope.fileParentext = files[0].name.substr(files[0].name.lastIndexOf('.'));
            if ($scope.allowedExt.indexOf($scope.fileParentext.toLowerCase()) < 0) {

                allowed = false;
                $scope.filParentext = '';
                $scope.ParentFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            } else {

                $scope.filenameParent = files[0].name;
            }
        };

        $scope.selectOthers = function (files) {

            $scope.OthersFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {

                if (allowed)
                    $scope.fileOthers = btoa(e.target.result.toString());
            };

            reader.readAsBinaryString(files[0]);
            $scope.fileOthersext = files[0].name.substr(files[0].name.lastIndexOf('.'));
            if ($scope.allowedExt.indexOf($scope.fileOthersext.toLowerCase()) < 0) {

                allowed = false;
                $scope.fileOthersext = '';
                $scope.OthersFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            } else {

                $scope.filenameOthers = files[0].name;
            }
        };

        $scope.clickRemoveOthers = function (file, event, key) {

            event.preventDefault();
            $scope.fileOthers = "";
            $scope.filenameOthers = "";
            $scope.fileOthersext = "x";
            $scope.OthersFile.splice(key, 1);
            $scope.OthersFile = [];
            return null;
        };

        $scope.clickRemoveParent = function (file, event, key) {

            event.preventDefault();
            $scope.fileParent = "";
            $scope.filenameParent = "";
            $scope.fileParentext = "x";
            $scope.ParentFile.splice(key, 1);
            $scope.ParentFile = [];
            return null;
        };

        $scope.clickRemoveNPWP = function (file, event, key) {

            event.preventDefault();
            $scope.fileNPWP = "";
            $scope.filenameNPWP = "";
            $scope.fileNPWPext = "x";
            $scope.NPWPFile.splice(key, 1);
            $scope.NPWPFile = [];
            return null;
        };
        //--------------------------------------------End Setting--------------------------------------------

        $scope.listBankRDN = ['BCA (Online)', 'MANDIRI (Offline)', 'CIMB (Offline)', 'MAYAPADA (Offline)'];
        $scope.rdnbca = $scope.listBankRDN[0];
        $scope.bankRDN = '';
        $scope.PhoneCode = '+62';
        $scope.CIFInvestor = {}
        $scope.CIFInvestor.HomePhoneCode = '021';
        $scope.bankpribadi = '';

        $scope.OPBBCA = {
            occupation: '',
            occupationText: '',
            position: '',
            positionText: '',
            business: '',
            businessText: ''
        }

        $scope.CIFInvestor = {
            occupation: '',
            occupationText: '',
            position: '',
            positionText: '',
            business: '',
            businessText: '',
            CIFInvestorBeneficiaryOwnerOccupation: ''
        }

        $scope.OPBOTHER = {
            occupation: '',
            occupationText: '',
            position: '',
            positionText: '',
            business: '',
            businessText: ''
        }

        $scope.OPSPOUSE = {
            occupation: '',
            occupationText: '',
            position: '',
            business: '',
        }

        $scope.disableBank = true;
        $scope.disableCIFInvestorQuestionRDN = false;

        $scope.selectedFundSource = [];
        $scope.selectedSpouseFundSource = [];

        $scope.fundsource1 = [
      {
          id: 1,
          name: 'Lainnya'
      },
      {
          id: 2,
          name: 'Gaji'
      },
      {
          id: 3,
          name: 'Hasil Usaha'
      },
      //{
      //    id: 4,
      //    name: 'Tabungan'
      //},
       {
           id: 5,
           name: 'Warisan'
       }
        ];


        $scope.fundsourcebo = [
      {
          id: 1,
          name: 'Lainnya'
      },
      {
          id: 2,
          name: 'Gaji'
      },
      {
          id: 3,
          name: 'Hasil Usaha'
      },
      //{
      //    id: 4,
      //    name: 'Tabungan'
      //},
       {
           id: 5,
           name: 'Warisan'
       }
        ];

        $scope.spousefundsource1 = [
      {
          id: 1,
          name: 'Lainnya'
      },
      {
          id: 2,
          name: 'Gaji'
      },
      {
          id: 3,
          name: 'Hasil Usaha'
      },
      //{
      //    id: 4,
      //    name: 'Tabungan'
      //},
       {
           id: 5,
           name: 'Warisan'
       }
        ];

        $scope.ListBank = {};
        $scope.listpekerjaan_BCA = {};
        $scope.listjabatan_BCA = {};
        $scope.listusaha_BCA = {};
        $scope.listpekerjaan_PERMATA = {};
        $scope.listjabatan_PERMATA = {};
        $scope.listusaha_PERMATA = {};
        $scope.listpekerjaan_BUKOPIN = {};
        $scope.listjabatan_BUKOPIN = {};
        $scope.listusaha_BUKOPIN = {};
        $scope.ListLookup = [];
        $scope.ListLookupBukopin = [];
        $scope.ListOccupation = [];
        $scope.ListSpouseIncome = [];

        $scope.ListKecamatanCompany = [];
        $scope.ListKelurahanCompany = [];

        $scope.CompanyCountrySelected = '';
        $scope.CompanyCityBOSelected = '';
        $scope.ListKecamatanCompanyBO = [];
        $scope.ListKelurahanCompanyBO = [];
        $scope.selectedFundSourceBO = [];
        $scope.ListKecamatanBO = [];
        $scope.ListKelurahanBO = [];

        $scope.NationalitySelected = '';
        $scope.ListNationality = [];

        $scope.chkSeumurHidup = true;
        $scope.DisabledSeumurHidup = true;
        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerIDCardExpiredDate = new Date(9998, 11, 31);

        $scope.CompanyCitySelected = '';
        $scope.SpouseCompanyCitySelected = '';
        $scope.mustSelect = function (event, field) {

            if (event.keyCode == 27) {

                let returnValue = true;
                switch (field) {

                    case 'CompanyCity': $scope.CIFInvestor.CompanyCity = ''; returnValue = false;
                        break;
                    case 'IDCard': $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCity = ''; returnValue = false;
                        break;
                    case 'CompanyBO': $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity = ''; returnValue = false;
                        break;
                    default:
                        break;
                }
                return returnValue;
            }
            return true;
        }
        $scope.selectCity = function (item, model, label, event) {

            if (item.CIFProvinceCityNID) {

                $scope.CIFInvestor.SpouseCompanyCity = item.CIFProvinceCityNID;
            }
        };
        $scope.selectIDCardCityBO = function (item, model, label, event) {
            $scope.ListKecamatanBO = '';
            $scope.ListKelurahanBO = '';

            if (item.CIFProvinceCityNID) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCity = item.CIFProvinceCityNID;

                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                    cache: true,
                }).then(function (data) {
                    $scope.ListKecamatanBO = data.data.d;
                    $scope.kecamatanChangeBO();
                }, function (error) { });

            }

        };

        $scope.kecamatanChangeBO = function () {
            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan) {
                $scope.ListKelurahanBO = $filter('filter')($scope.ListKecamatanBO, { Kecamatan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan }, true);
            }
        }

        $scope.kelurahanChangeBO = function () {
            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKelurahan) {
                let temp = $filter('filter')($scope.ListKecamatanBO, { Kelurahan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKelurahan }, true);
                if (temp) {
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerPostalCode = temp[0].PostalCode;
                }
            }
        }

        $scope.selectIDCardCountry = function (item, model, label, event) {
            if (item.CIFCountryNID) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNationality = item.CIFCountryNID;
            }
        };

        $scope.selectCompanyCityBO = function (item, model, label, event) {
            $scope.ListKecamatanCompanyBO = '';
            $scope.ListKelurahanCompanyBO = '';

            if (item.CIFProvinceCityNID) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity = item.CIFProvinceCityNID;
                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                    cache: true,
                }).then(function (data) {
                    $scope.ListKecamatanCompanyBO = data.data.d;
                    $scope.kecamatanChangeCompanyCityBO();
                }, function (error) { });
            }

        };

        $scope.kecamatanChangeCompanyCityBO = function () {
            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyAddress2) {
                $scope.ListKelurahanCompanyBO = $filter('filter')($scope.ListKecamatanCompanyBO, { Kecamatan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyAddress2 }, true);
            }
        }

        $scope.kelurahanChangeCompanyCityBO = function () {
            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyAddress3) {
                let temp = $filter('filter')($scope.ListKecamatanCompanyBO, { Kelurahan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyAddress3 }, true);
                if (temp) {
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyPostalCode = temp[0].PostalCode;
                }
            }
        }

        $scope.selectCompanyCity = function (item, model, label, event) {
            $scope.ListKecamatanCompany = '';
            $scope.ListKelurahanCompany = '';

            if (item.CIFProvinceCityNID) {
                $scope.CIFInvestor.CompanyCity = item.CIFProvinceCityNID;
                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                    cache: true,
                }).then(function (data) {
                    $scope.ListKecamatanCompany = data.data.d;
                    $scope.kecamatanChangeCompanyCity();
                }, function (error) { });
            }

        };


        $scope.kecamatanChangeCompanyCity = function () {
            if ($scope.CIFInvestor.CompanyKecamatan) {
                $scope.ListKelurahanCompany = $filter('filter')($scope.ListKecamatanCompany, { Kecamatan: $scope.CIFInvestor.CompanyKecamatan }, true);
            }
        }

        $scope.kelurahanChangeCompanyCity = function () {
            if ($scope.CIFInvestor.CompanyKelurahan) {
                let temp = $filter('filter')($scope.ListKecamatanCompany, { Kelurahan: $scope.CIFInvestor.CompanyKelurahan }, true);
                if (temp) {
                    $scope.CIFInvestor.CompanyPostalCode = temp[0].PostalCode;
                }
            }
        }


        $scope.questionRDNchange = function () {

            $scope.OPBBCA.occupation = '';
            $scope.OPBBCA.occupationText = '';
            $scope.OPBBCA.position = '';
            $scope.OPBBCA.positionText = '';
            $scope.OPBBCA.business = '';
            $scope.OPBBCA.businessText = '';

            $scope.CIFInvestor.occupation = '';
            $scope.CIFInvestor.occupationText = '';
            $scope.CIFInvestor.position = '';
            $scope.CIFInvestor.positionText = '';

            $scope.OPBOTHER.occupation = '';
            $scope.OPBOTHER.occupationText = '';
            $scope.OPBOTHER.position = '';
            $scope.OPBOTHER.positionText = '';
            $scope.OPBOTHER.business = '';
            $scope.OPBOTHER.businessText = '';

            $scope.CIFInvestor.BankName = "";
            $scope.disableBank = false;

            if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

                $scope.bankpribadi = "PT. BANK CENTRAL ASIA, Tbk.";
                $scope.disableBank = true;
            }
        };


        $scope.changeSpouseMandatory = function (param) {

            if (param) {

                $scope.spouseMandatory = true;
            } else {
                let flag = false;

                if ($scope.OPBBCA) {

                    if ($scope.OPBBCA.occupation.key == 1 || $scope.OPBBCA.occupation.key == 2) {

                        flag = true;
                        $scope.spouseMandatory2 = true;
                        $scope.spouseMandatory1 = false
                    }
                }

                if ($scope.CIFInvestor.QuestionRDN == '2') {
                    if ($scope.CIFInvestor.Occupation.key == 3 || $scope.CIFInvestor.Occupation.key == 4) {

                        flag = true;
                        $scope.spouseMandatory2 = true;
                        $scope.spouseMandatory1 = false
                    }
                }

                if ($scope.OPBOTHER) {

                    if ($scope.OPBOTHER.CIFLookupInteger == 4 || $scope.OPBOTHER.CIFLookupInteger == 6) {

                        flag = true;
                        $scope.spouseMandatory2 = true;
                        $scope.spouseMandatory1 = false;
                    }

                }

                if ($scope.CIFInvestor.QuestionRDN == '3') {

                    if ($scope.CIFInvestor.Occupation.key == 4 || $scope.CIFInvestor.Occupation.key == 6) {

                        flag = true;
                        $scope.spouseMandatory2 = true;
                        $scope.spouseMandatory1 = false;
                    }

                }


                if ($scope.selectedFundSource.indexOf(7) > -1) {

                    flag = true;
                    $scope.spouseMandatory2 = true;
                    $scope.spouseMandatory1 = false;
                }

                if ($scope.selectedFundSource.indexOf(6) > -1) {

                    flag = true;
                    $scope.spouseMandatory1 = true;
                    $scope.spouseMandatory2 = false;
                }

                if (!flag) {

                    $scope.CIFInvestor.SpouseCompanyName = '';
                    $scope.CIFInvestor.SpouseIncomePerAnnum = '';
                    $scope.CIFInvestor.SpouseIncomeExtraPerAnnum = '';
                    $scope.CIFInvestor.SpouseOccupation = '';
                    $scope.CIFInvestor.SpousePosition = '';
                    $scope.CIFInvestor.SpouseNatureOfBusiness = '';
                    $scope.CIFInvestor.SpouseCompanyCity = '';
                    $scope.CIFInvestor.SpouseCompanyPostalCode = '';
                    $scope.CIFInvestor.SpouseCompanyAddress = '';
                    $scope.CIFInvestor.SpouseFundSource = '';

                    $scope.SpouseCompanyCitySelected = '';
                    $scope.selectedSpouseFundSource = [];

                    $scope.OPSPOUSE.occupation = '';
                    $scope.OPSPOUSE.occupationText = '';
                    $scope.OPSPOUSE.position = '';
                    $scope.OPSPOUSE.business = '';
                }

                $scope.spouseMandatory = flag;

                console.log('spouseMandatory   ', $scope.spouseMandatory)
            }
        }

        $scope.bo = function () {

            if ($scope.CIFInvestor.QuestionNPWP == 2) {
                var SWALtranslate = $scope.SWALtranslate('npwp');

                Swal.fire({
                    text: SWALtranslate.message,
                    imageAlt: 'BO',
                    imageHeight: 250,
                    animation: false
                });
            }
        }

        $scope.NPWPNumber = function () {
            if ($scope.CIFInvestor.QuestionNPWP == 1) {
                $scope.CIFInvestor.NPWPNumber = $scope.CIFInvestor.IDCardNumber
                $scope.disabledNPWPNumber = true;
            }
        };

        $scope.updateNPWP = function () {

            if ($scope.CIFInvestor.NPWPNumber) {

                if ($scope.CIFInvestor.QuestionNPWP == 1) {

                    $scope.CIFInvestor.NPWPNumber;
                } else {
                    $scope.CIFInvestor.NPWPReason;
                    $scope.CIFInvestor.NPWPNumber = '';

                }
            }
        };

        $scope.occupationChange_BCA = function () {

            if ($scope.OPBBCA.occupation) {

                $scope.OPBBCA.occupationText = '';
                $scope.OPBBCA.position = 0;
                $scope.OPBBCA.positionText = '';
                $scope.OPBBCA.business = 0;
                $scope.OPBBCA.businessText = '';

                if ($scope.OPBBCA.occupation.key == 1 || $scope.OPBBCA.occupation.key == 2)
                    $scope.changeSpouseMandatory(true);
                else
                    $scope.changeSpouseMandatory();
                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetJabatan?Pekerjaan=' + $scope.OPBBCA.occupation.key,
                }).then(function (data) {


                    $scope.listjabatan_BCA = data.data.d;

                    if ($scope.listjabatan_BCA.length) {
                        $scope.OPBBCA.positionText = '';
                        $scope.OPBBCA.position = $scope.listjabatan_BCA[0];

                        $scope.positionChange_BCA();
                    }
                }, function (error) { });
            }
        };

        $scope.positionChange_BCA = function () {
            $http({
                method: 'GET',
                url: '/service/client.svc/GetBidangUsaha?Jabatan=' + $scope.OPBBCA.position.key + '&Pekerjaan=' + $scope.OPBBCA.occupation.key,
            }).then(function (data) {

                $scope.listusaha_BCA = data.data.d;

                if ($scope.listusaha_BCA.length) {

                    $scope.OPBBCA.businessText = '';
                    $scope.OPBBCA.business = $scope.listusaha_BCA[0];
                }
            }, function (error) { });
        };

        $scope.occupationChange_PERMATA = function () {

            if ($scope.CIFInvestor.Occupation) {

                $scope.CIFInvestor.OccupationText = '';
                $scope.CIFInvestor.Position = 0;
                $scope.CIFInvestor.PositionText = '';
                $scope.CIFInvestor.NatureOfBusiness = 0;
                $scope.CIFInvestor.NatureOfBusinessText = '';

                if ($scope.CIFInvestor.Occupation.key == 3 || $scope.CIFInvestor.Occupation.key == 4)
                    $scope.changeSpouseMandatory(true);
                else
                    $scope.changeSpouseMandatory();

                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetJabatanPermata?Pekerjaan=' + $scope.CIFInvestor.Occupation.key,
                }).then(function (data) {

                    $scope.listjabatan_PERMATA = data.data.d;

                    if ($scope.listjabatan_PERMATA.length) {
                        $scope.CIFInvestor.PositionText = '';
                        $scope.CIFInvestor.Position = $scope.listjabatan_PERMATA[0];

                        //$scope.positionChange_PERMATA();
                    }
                }, function (error) { });
            }

            console.log($scope.CIFInvestor.Occupation);
        };

        $scope.occupationChange_BUKOPIN = function () {

            if ($scope.CIFInvestor.Occupation) {

                $scope.CIFInvestor.OccupationText = '';
                $scope.CIFInvestor.Position = 0;
                $scope.CIFInvestor.PositionText = '';
                $scope.CIFInvestor.NatureOfBusiness = 0;
                $scope.CIFInvestor.NatureOfBusinessText = '';

                if ($scope.CIFInvestor.Occupation.key == 4) {
                    $scope.CIFInvestor.Position = 3;
                    $scope.CIFInvestor.PositionText = 'IBU RUMAH TANGGA';
                    $scope.CIFInvestor.NatureOfBusiness = 33;
                    $scope.CIFInvestor.businessText = 'IBU RUMAH TANGGA';
                }

                if ($scope.CIFInvestor.Occupation.key == 6) {
                    $scope.CIFInvestor.Position = 0;
                    $scope.CIFInvestor.PositionText = 'MAHASISWA/PELAJAR';
                    $scope.CIFInvestor.NatureOfBusiness = 0;
                    $scope.CIFInvestor.businessText = 'MAHASISWA/PELAJAR';
                }

                if ($scope.CIFInvestor.Occupation.key == 4 || $scope.CIFInvestor.Occupation.key == 6)
                    $scope.changeSpouseMandatory(true);
                else
                    $scope.changeSpouseMandatory();


            }
        };

        $scope.occupationChange_OTHER = function () {

            if ($scope.OPBOTHER.occupation) {

                $scope.OPBOTHER.occupationText = '';
                $scope.OPBOTHER.position = '';
                $scope.OPBOTHER.positionText = '';
                $scope.OPBOTHER.business = '';
                $scope.OPBOTHER.businessText = '';

                if ($scope.OPBOTHER.occupation == '4' || $scope.OPBOTHER.occupation == '6')
                    $scope.changeSpouseMandatory(true);
                else
                    $scope.changeSpouseMandatory();
            }
        }

        $scope.toggleFundSourceItem = function (fundsource) {

            let indexCIFLookupInteger = $scope.selectedFundSource.indexOf(fundsource.id);

            if (indexCIFLookupInteger > -1)
                $scope.selectedFundSource.splice(indexCIFLookupInteger, 1);
            else
                $scope.selectedFundSource.push(fundsource.id);

            if ($scope.selectedFundSource.indexOf(1) < 0)
                $scope.CIFInvestor.FundSourceText = '';

            $scope.changeSpouseMandatory();
        }

        $scope.toggleSpouseFundSourceItem = function (fundsource) {

            $scope.CIFInvestor.SpouseFundSource = '';
            let indexCIFLookupInteger = $scope.selectedSpouseFundSource.indexOf(fundsource.id);

            if (indexCIFLookupInteger > -1)
                $scope.selectedSpouseFundSource.splice(indexCIFLookupInteger, 1);
            else
                $scope.selectedSpouseFundSource.push(fundsource.id);

            if ($scope.selectedSpouseFundSource.indexOf(1) < 0)
                $scope.CIFInvestor.SpouseFundSourceText = '';
        }


        $scope.toggleFundSourceBOItem = function (fundsource) {

            let indexCIFLookupInteger = $scope.selectedFundSourceBO.indexOf(fundsource.id);

            if (indexCIFLookupInteger > -1)
                $scope.selectedFundSourceBO.splice(indexCIFLookupInteger, 1);
            else
                $scope.selectedFundSourceBO.push(fundsource.id);

            if ($scope.selectedFundSourceBO.indexOf(1) < 0)
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSourceText = '';

            $scope.changeSpouseMandatory();
        }

        $scope.prepareData = function () {

            if ($scope.CIFInvestor.IncomeExtraPerAnnum == '') {
                $scope.CIFInvestor.IncomeExtraPerAnnum == 0;
            }


            if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

                $scope.CIFInvestor.BankName = $scope.bankpribadi;
                $scope.CIFInvestor.Occupation = $scope.OPBBCA.occupation.key;
                $scope.CIFInvestor.OccupationText = $scope.OPBBCA.occupationText;
                $scope.CIFInvestor.Position = $scope.OPBBCA.position.key;
                $scope.CIFInvestor.PositionText = $scope.OPBBCA.positionText;
                $scope.CIFInvestor.NatureOfBusiness = $scope.OPBBCA.business.key;
                $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBBCA.businessText;
            } else if ($scope.CIFInvestor.QuestionRDN == '2' || $scope.CIFInvestor.QuestionRDN == 2) {
                $scope.CIFInvestor.BankName = $scope.bankpribadi;
                $scope.CIFInvestor.Occupation = $scope.CIFInvestor.Occupation.key;
                console.log($scope.CIFInvestor.Occupation);
                if ($scope.CIFInvestor.Occupation == 7) {
                    $http({
                        method: 'GET',
                        url: '/service/client.svc/GetJabatanPERMATA?Pekerjaan=' + $scope.CIFInvestor.Occupation.key,
                    }).then(function (data) {
                        $scope.listjabatan_PERMATA = data.data.d;
                        $scope.OccupationText = $filter('filter')($scope.listjabatan_PERMATA, { key: $scope.CIFInvestor.Occupation }, true)[0];
                        $scope.CIFInvestor.OccupationText = OccupationText.NAMA_Pekerjaan;
                    }, function (error) { });
                }
                else {
                    $scope.CIFInvestor.OccupationText = $scope.CIFInvestor.OccupationText;
                }
                $scope.CIFInvestor.Position = $scope.CIFInvestor.Position.key;
                $scope.CIFInvestor.PositionText = $scope.CIFInvestor.PositionText;
                $scope.CIFInvestor.NatureOfBusiness = Number($scope.CIFInvestor.NatureOfBusiness);
                $scope.CIFInvestor.NatureOfBusinessText = $scope.CIFInvestor.businessText;
            }
            else if ($scope.CIFInvestor.QuestionRDN == '3' || $scope.CIFInvestor.QuestionRDN == 3) {
                $scope.CIFInvestor.BankName = $scope.bankpribadi;
                $scope.CIFInvestor.Occupation = $scope.CIFInvestor.Occupation.key;
                if ($scope.CIFInvestor.Occupation == 4 || $scope.CIFInvestor.Occupation == 6) {
                    $scope.CIFInvestor.Position = 3;
                    $scope.CIFInvestor.PositionText = $scope.CIFInvestor.PositionText;
                    $scope.CIFInvestor.NatureOfBusiness = 33;
                    $scope.CIFInvestor.NatureOfBusinessText = $scope.CIFInvestor.businessText;
                } else {
                    $scope.CIFInvestor.Position = $scope.CIFInvestor.Position.key;
                    $scope.CIFInvestor.PositionText = $scope.CIFInvestor.PositionText;
                    $scope.CIFInvestor.NatureOfBusiness = Number($scope.CIFInvestor.NatureOfBusiness.key);
                    $scope.CIFInvestor.NatureOfBusinessText = $scope.CIFInvestor.businessText;
                }
            }
            else {
                $scope.CIFInvestor.Occupation = Number($scope.OPBOTHER.occupation);
                $scope.CIFInvestor.BankName = $scope.bankpribadi;
                $scope.CIFInvestor.OccupationText = $scope.OPBOTHER.occupationText;
                $scope.CIFInvestor.Position = 0;
                $scope.CIFInvestor.NatureOfBusiness = 0;

                if ($scope.OPBOTHER.occupation == '4') {

                    $scope.CIFInvestor.PositionText = '';
                    $scope.CIFInvestor.NatureOfBusinessText = '';
                } else {

                    $scope.CIFInvestor.PositionText = $scope.OPBOTHER.positionText;
                    $scope.CIFInvestor.NatureOfBusiness = 0;
                    $scope.CIFInvestor.NatureOfBusinessText = $scope.OPBOTHER.businessText;
                }
            }

            //if ($scope.CIFInvestor.Position != '0') {
            //    $scope.CIFInvestor.PositionText = null;
            //}

            //if ($scope.CIFInvestor.NatureOfBusiness != '0') {
            //    $scope.CIFInvestor.NatureOfBusinessText = null;
            //}

            if ($scope.spouseMandatory) {

                $scope.CIFInvestor.SpouseOccupation = Number($scope.OPSPOUSE.occupation);
                $scope.CIFInvestor.SpouseOccupationText = $scope.OPSPOUSE.occupationText;
                $scope.CIFInvestor.SpousePosition = $scope.OPSPOUSE.position;
                $scope.CIFInvestor.SpouseNatureOfBusiness = ($scope.OPSPOUSE.business);
                //$scope.CIFInvestor.SpouseCompanyCity = Number($scope.SpouseCompanyCitySelected);
                $scope.CIFInvestor.SpouseIncomeExtraPerAnnum = Number($scope.CIFInvestor.SpouseIncomeExtraPerAnnum);
                $scope.CIFInvestor.SpouseIncomePerAnnum = Number($scope.CIFInvestor.SpouseIncomePerAnnum);
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation = Number($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerOccupation);
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerIncomePerAnnum = Number($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerIncomePerAnnum);
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerSex = Number($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerSex);
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerInvestmentObjectives = Number($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerInvestmentObjectives);

            } else {

                $scope.CIFInvestor.SpouseIncomePerAnnum = 0;
                $scope.CIFInvestor.SpouseIncomeExtraPerAnnum = 0;
                $scope.CIFInvestor.SpouseOccupation = 0;
                $scope.CIFInvestor.SpouseCompanyCity = 0;
            }

            if ($scope.selectedFundSource) {

                $scope.CIFInvestor.FundSource = '';

                for (var i = 0; i < $scope.selectedFundSource.length; i++) {

                    if ($scope.CIFInvestor.FundSource.length > 0)
                        $scope.CIFInvestor.FundSource += ',';
                    $scope.CIFInvestor.FundSource += $scope.selectedFundSource[i];
                }
            }


            if ($scope.selectedSpouseFundSource) {

                $scope.CIFInvestor.SpouseFundSource = '';

                for (var i = 0; i < $scope.selectedSpouseFundSource.length; i++) {

                    if ($scope.CIFInvestor.SpouseFundSource.length > 0)
                        $scope.CIFInvestor.SpouseFundSource += ',';
                    $scope.CIFInvestor.SpouseFundSource += $scope.selectedSpouseFundSource[i];
                }
            }

            if ($scope.selectedFundSourceBO) {
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource = '';
                for (var i = 0; i < $scope.selectedFundSourceBO.length; i++) {
                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource.length > 0)
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource += ',';
                    $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource += $scope.selectedFundSourceBO[i];

                }
            }


            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity)
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity = Number($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyCity);

            if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNationality)
                $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNationality = Number($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerNationality);
        };

        $scope.validation = false;

        $scope.validationinput = function () {

            var errorForm = $scope.myForm.$error.required
            $scope.validation = $scope.myForm.$valid;
            var message = [];
            //console.log('error :', errorForm);

            if (errorForm) {
                for (let i = 0; i < errorForm.length; i++) {
                    //message += errorForm[i].$name + " , ";
                    message.push(errorForm[i].$name);
                }
            }

            if (($scope.CIFInvestor.QuestionRDN == 1 && $scope.OPBBCA.occupation.key == 1 || $scope.CIFInvestor.QuestionRDN == 1 && $scope.OPBBCA.occupation.key == 2) || ($scope.CIFInvestor.QuestionRDN == 2 && $scope.CIFInvestor.Occupation == 3 || $scope.CIFInvestor.QuestionRDN == 2 && $scope.CIFInvestor.Occupation.key == 4)) {
                if (!$scope.othersPhoto) {
                    $scope.validation = false
                    message.push("othersPhoto");
                }
            }

            if ($scope.CIFInvestor.QuestionRDN == 1 && $scope.OPBBCA.occupation.key == 1 || ($scope.CIFInvestor.QuestionRDN == 2 && $scope.CIFInvestor.Occupation.key == 3) || ($scope.CIFInvestor.QuestionRDN == 3 && $scope.CIFInvestor.Occupation.key == 6)) {
                if (!$scope.parentPhoto) {
                    $scope.validation = false
                    message.push("parentPhoto");
                }
            }

            //PROSES VALIDATION
            if ($scope.validation == false) {
                console.log("error : " + message);

                var SWALtranslate = $scope.SWALtranslate('validationinput');
                Swal.fire({
                    title: SWALtranslate.title,
                    text: SWALtranslate.message,
                    imageUrl: 'img/collection/wrong.png',
                    imageAlt: 'Preparation',
                    imageHeight: 250,
                    animation: false
                });
            }

        }


        var allPromise = $q.all([

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFProvinceCity',
            cache: true,
        }).then(function (data) {

            $scope.ListProvinceCity = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFBank',
            cache: true,
        }).then(function (data) {

            $scope.ListBank = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFLookup',
            cache: true,
        }).then(function (data) {

            $scope.ListLookup = data.data.d;

            if ($scope.ListLookup) {
                $scope.ListOccupation = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Occupation' }, true);
                $scope.ListSpouseIncome = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                $scope.ListFundSource = $filter('filter')($scope.ListLookup, { CIFLookupID: 'FundSource' }, true);
                $scope.ListIncomePerAnnum = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                $scope.ListInvestmentObjectives = $filter('filter')($scope.ListLookup, { CIFLookupID: 'InvestmentObjectives' }, true);

            }
        }, function (error) { }),

           $http({
               method: 'GET',
               url: '/service/client.svc/GetCIFBank',
               cache: true,
           }).then(function (data) {

               $scope.ListBank = data.data.d;
           }, function (error) { }),

            $http({
                method: 'GET',
                url: '/service/client.svc/GetCIFPekerjaan',
                cache: true,
            }).then(function (data) {
                $scope.listpekerjaan_BCA = data.data.d;
            }, function (error) { }),

            $http({
                method: 'GET',
                url: '/service/client.svc/GetJabatan',
                cache: true,
            }).then(function (data) {
                $scope.listposition_BCA = data.data.d;
            }, function (error) { }),

            $http({
                method: 'GET',
                url: '/service/client.svc/GetBidangUsaha',
                cache: true,
            }).then(function (data) {
                $scope.listnature_BCA = data.data.d;
            }, function (error) { }),

             $http({
                 method: 'GET',
                 url: '/service/client.svc/GetCIFPekerjaanPermata',
                 cache: true,
             }).then(function (data) {

                 $scope.listpekerjaan_PERMATA = data.data.d;
             }, function (error) { }),

              $http({
                  method: 'GET',
                  url: '/service/client.svc/GetJabatanPermata',
                  cache: true,
              }).then(function (data) {
                  $scope.listposition_PERMATA = data.data.d;
              }, function (error) { }),

                $http({
                    method: 'GET',
                    url: '/service/client.svc/GetBidangUsahaPermata',
                    cache: true,
                }).then(function (data) {

                    $scope.listnature_PERMATA = data.data.d;
                }, function (error) { }),

                //GetDataBukopin
                 $http({
                     method: 'GET',
                     url: '/service/client.svc/GetCIFPekerjaanBukopin?TypeID=Occupation',
                     cache: true,
                 }).then(function (data) {

                     $scope.listpekerjaan_BUKOPIN = data.data.d;
                 }, function (error) { }),

                 $http({
                     method: 'GET',
                     url: '/service/client.svc/GetCIFPekerjaanBukopin?TypeID=Position',
                     cache: true,
                 }).then(function (data) {

                     $scope.listjabatan_BUKOPIN = data.data.d;
                 }, function (error) { }),

                 $http({
                     method: 'GET',
                     url: '/service/client.svc/GetCIFPekerjaanBukopin?TypeID=NatureOfBusiness',
                     cache: true,
                 }).then(function (data) {

                     $scope.listnature_BUKOPIN = data.data.d;
                 }, function (error) { }),

        ]);

        allPromise.then(function () {

            $http({
                method: 'GET',
                url: '/service/client.svc/getCIF',
                cache: true,
            }).then(function (data) {
                if (data.data.d != null) {
                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;
                    $scope.CIFInvestor.Stage = 3;
                    $scope.CIFInvestor.business = data.data.d.NatureOfBusiness;
                    //info upload 
                    $scope.filenameNPWP = $scope.CIFInvestor.NPWPFile;
                    $scope.filenameOthers = $scope.CIFInvestor.OthersFile;
                    $scope.filenameParent = $scope.CIFInvestor.ParentFile;
                    if ($scope.filenameNPWP) {

                        if (!$scope.filenameNPWP.endsWith(".pdf")) {
                            $http({
                                method: 'GET',
                                url: 'FileKYC/' + $scope.filenameNPWP,
                                responseType: 'blob',

                            }).then(function (response) {
                                if (response.data) {
                                    var reader2 = new FileReader();
                                    reader2.readAsDataURL(response.data);
                                    reader2.onloadend = function () {
                                        $scope.npwpPhoto = reader2.result;
                                    }

                                }
                                //$scope.NPWPFile = [];
                                //$scope.NPWPFile.push(response.data);
                            }, function (response) {
                                $scope.saveErrors = true;
                                $scope.errorMessages = {
                                    text: 'File tidak ketemu atau terhapus dari server!!!',
                                };
                                $timeout(function () {
                                    $scope.saveErrors = false;
                                }, 3000);
                            });
                        }
                    };
                    if ($scope.filenameOthers) {

                        if (!$scope.filenameOthers.endsWith(".pdf")) {
                            $http({
                                method: 'GET',
                                url: 'FileKYC/' + $scope.filenameOthers,
                                responseType: 'blob',

                            }).then(function (response) {
                                if (response.data) {
                                    var reader5 = new FileReader();
                                    reader5.readAsDataURL(response.data);
                                    reader5.onloadend = function () {
                                        $scope.othersPhoto = reader5.result;
                                    }

                                }
                                //$scope.tandatanganFile = [];
                                //$scope.tandatanganFile.push(response.data);
                            }, function (response) {
                                $scope.saveErrors = true;
                                $scope.errorMessages = {
                                    text: 'File tidak ketemu atau terhapus dari server!!!',
                                };
                                $timeout(function () {
                                    $scope.saveErrors = false;
                                }, 3000);
                            });
                        }
                    };
                    if ($scope.filenameParent) {

                        if (!$scope.filenameParent.endsWith(".pdf")) {
                            $http({
                                method: 'GET',
                                url: 'FileKYC/' + $scope.filenameParent,
                                responseType: 'blob',

                            }).then(function (response) {
                                if (response.data) {
                                    var reader6 = new FileReader();
                                    reader6.readAsDataURL(response.data);
                                    reader6.onloadend = function () {
                                        $scope.parentPhoto = reader6.result;
                                    }

                                }
                                //$scope.tandatanganFile = [];
                                //$scope.tandatanganFile.push(response.data);
                            }, function (response) {
                                $scope.saveErrors = true;
                                $scope.errorMessages = {
                                    text: 'File tidak ketemu atau terhapus dari server!!!',
                                };
                                $timeout(function () {
                                    $scope.saveErrors = false;
                                }, 3000);
                            });
                        }
                    };
                    //end info upload

                    if ($scope.CIFInvestor.QuestionRDN == 0) {

                        $scope.CIFInvestor.QuestionRDN = '';
                    }

                    if ($scope.CIFInvestor.BankOwner == '' || !$scope.CIFInvestor.BankOwner)
                        $scope.CIFInvestor.BankOwner = $scope.CIFInvestor.FirstName;

                    if ($scope.CIFInvestor.QuestionNPWP == 0)
                        $scope.CIFInvestor.QuestionNPWP = '';

                    $scope.bankpribadi = $scope.CIFInvestor.BankName;


                    if ($scope.CIFInvestor.SpouseCompanyCity)
                        $scope.SpouseCompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.DomicileCity }, true)[0];

                    if (data.data.d.CompanyCity) {
                        $scope.CompanyCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.CompanyCity }, true)[0];
                        $http({
                            method: 'GET',
                            url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.CompanyCity,
                            cache: true,
                        }).then(function (dataKecamatan) {
                            $scope.ListKecamatanCompany = dataKecamatan.data.d;
                            if ($scope.ListKecamatanCompany)
                                $scope.ListKelurahanCompany = $filter('filter')($scope.ListKecamatanCompany, { Kecamatan: $scope.CIFInvestor.CompanyKecamatan }, true);


                        }, function (error) { });
                    }


                    if (data.data.d.SpouseBirthDate)
                        $scope.CIFInvestor.SpouseBirthDate = new Date(data.data.d.SpouseBirthDate);

                    if ($scope.CIFInvestor.QuestionRDN) {

                        //BCA
                        if ($scope.CIFInvestor.QuestionRDN == '1' || $scope.CIFInvestor.QuestionRDN == 1) {

                            $scope.OPBBCA.occupationText = $scope.CIFInvestor.OccupationText;
                            $scope.OPBBCA.positionText = $scope.CIFInvestor.PositionText;
                            $scope.OPBBCA.businessText = $scope.CIFInvestor.NatureOfBusinessText;

                            if ($scope.CIFInvestor.Occupation && $scope.CIFInvestor.Occupation > 0) {

                                $scope.OPBBCA.occupation = $filter('filter')($scope.listpekerjaan_BCA, { key: $scope.CIFInvestor.Occupation }, true)[0];


                                $http({
                                    method: 'GET',
                                    url: '/service/client.svc/GetJabatan?Pekerjaan=' + $scope.OPBBCA.occupation.key,
                                }).then(function (data) {

                                    $scope.listjabatan_BCA = data.data.d;

                                    if ($scope.listjabatan_BCA.length) {

                                        if ($scope.CIFInvestor.Position && $scope.CIFInvestor.Position > 0) {

                                            $scope.OPBBCA.position = $filter('filter')($scope.listjabatan_BCA, { key: $scope.CIFInvestor.Position }, true)[0];

                                            $http({
                                                method: 'GET',
                                                url: '/service/client.svc/GetBidangUsaha?Jabatan=' + $scope.OPBBCA.position.key + '&Pekerjaan=' + $scope.OPBBCA.occupation.key,
                                            }).then(function (data) {

                                                $scope.listusaha_BCA = data.data.d;

                                                if ($scope.listusaha_BCA.length) {

                                                    if ($scope.CIFInvestor.NatureOfBusiness != null)
                                                        $scope.OPBBCA.business = $filter('filter')($scope.listusaha_BCA, { key: $scope.CIFInvestor.NatureOfBusiness }, true)[0];
                                                }
                                            }, function (error) { });
                                        }
                                    }
                                }, function (error) { });
                            }

                        }
                            //PERMATA
                        else if ($scope.CIFInvestor.QuestionRDN == '2' || $scope.CIFInvestor.QuestionRDN == 2) {
                            $scope.CIFInvestor.businessText = $scope.CIFInvestor.NatureOfBusinessText;

                            if ($scope.CIFInvestor.Occupation && $scope.CIFInvestor.Occupation > 0) {

                                $scope.CIFInvestor.Occupation = $filter('filter')($scope.listpekerjaan_PERMATA, { key: $scope.CIFInvestor.Occupation }, true)[0];


                                $http({
                                    method: 'GET',
                                    url: '/service/client.svc/GetJabatanPermata?Pekerjaan=' + $scope.CIFInvestor.Occupation.key,
                                }).then(function (data) {

                                    $scope.listjabatan_PERMATA = data.data.d;

                                    if ($scope.listjabatan_PERMATA.length) {

                                        if ($scope.CIFInvestor.Position && $scope.CIFInvestor.Position > 0) {

                                            $scope.CIFInvestor.Position = $filter('filter')($scope.listjabatan_PERMATA, { key: $scope.CIFInvestor.Position }, true)[0];

                                        }
                                    }
                                }, function (error) { });
                            }
                            if ($scope.CIFInvestor.NatureOfBusiness != null) {
                                $scope.CIFInvestor.business = $filter('filter')($scope.listnature_PERMATA, { key: $scope.CIFInvestor.NatureOfBusiness }, true)[0];
                            }

                        }
                        else if ($scope.CIFInvestor.QuestionRDN == '3' || $scope.CIFInvestor.QuestionRDN == 3) {

                            $scope.CIFInvestor.NatureOfBusiness = $scope.CIFInvestor.business;
                            console.log($scope.CIFInvestor.NatureOfBusiness);

                            if ($scope.CIFInvestor.Occupation && $scope.CIFInvestor.Occupation > 0)
                                $scope.CIFInvestor.Occupation = $filter('filter')($scope.listpekerjaan_BUKOPIN, { key: $scope.CIFInvestor.Occupation }, true)[0];

                            if ($scope.CIFInvestor.Position && $scope.CIFInvestor.Position > 0)
                                $scope.CIFInvestor.Position = $filter('filter')($scope.listjabatan_BUKOPIN, { key: $scope.CIFInvestor.Position }, true)[0];

                            if ($scope.CIFInvestor.NatureOfBusiness != null)
                                $scope.CIFInvestor.NatureOfBusiness = $filter('filter')($scope.listnature_BUKOPIN, { key: $scope.CIFInvestor.NatureOfBusiness }, true)[0];
                        }
                        else {

                            $scope.OPBOTHER.occupation = $scope.CIFInvestor.Occupation;
                            $scope.OPBOTHER.occupationText = $scope.CIFInvestor.OccupationText;
                            $scope.OPBOTHER.position = $scope.CIFInvestor.Position;
                            $scope.OPBOTHER.positionText = $scope.CIFInvestor.PositionText;
                            $scope.OPBOTHER.business = $scope.CIFInvestor.NatureOfBusiness;
                            $scope.OPBOTHER.businessText = $scope.CIFInvestor.NatureOfBusinessText;
                        }
                    }

                    if ($scope.CIFInvestor.SpouseCompanyCity == '')
                        $scope.CIFInvestor.SpouseCompanyCity = 0;

                    if ($scope.CIFInvestor.CompanyCity == '')
                        $scope.CIFInvestor.CompanyCity = 0;

                    if ($scope.CIFInvestor.FundSource) {

                        $scope.selectedFundSource = [];
                        let temp = $scope.CIFInvestor.FundSource.split(',');

                        for (var i = 0; i < temp.length; i++) {

                            $scope.selectedFundSource.push(Number(temp[i]));
                        }
                    }

                    if ($scope.CIFInvestor.SpouseFundSource) {

                        $scope.selectedSpouseFundSource = [];
                        let temp = $scope.CIFInvestor.SpouseFundSource.split(',');

                        for (var i = 0; i < temp.length; i++) {

                            $scope.selectedSpouseFundSource.push(Number(temp[i]));
                        }
                    }

                    if ($scope.CIFInvestor.SpouseOccupation == 0)
                        $scope.CIFInvestor.SpouseOccupation = '';


                    if ($scope.CIFInvestor.Occupation == 0 || $scope.CIFInvestor.Occupation == null)
                        $scope.CIFInvestor.Occupation = null;

                    if ($scope.CIFInvestor.business == 0 || $scope.CIFInvestor.business == null)
                        $scope.CIFInvestor.NatureOfBusiness = null;

                    if ($scope.CIFInvestor.SpouseIncomePerAnnum == 0)
                        $scope.CIFInvestor.SpouseIncomePerAnnum = '';

                    if ($scope.CIFInvestor.IncomePerAnnum == 0)
                        $scope.CIFInvestor.IncomePerAnnum = '';

                    if ($scope.CIFInvestor.SpouseIncomeExtraPerAnnum == 0)
                        $scope.CIFInvestor.SpouseIncomeExtraPerAnnum = '';


                    if ($scope.CIFInvestor.IncomeExtraPerAnnum == null)
                        $scope.CIFInvestor.IncomeExtraPerAnnum = 0;

                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerInvestmentObjectives == null)
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerInvestmentObjectives = 0;

                    if (data.data.d.CIFInvestorBeneficiaryOwnerBirthDate)
                        $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerBirthDate = new Date(data.data.d.CIFInvestorBeneficiaryOwnerBirthDate);

                    if (data.data.d.CIFInvestorBeneficiaryOwnerCity) {
                        $scope.IDCardCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.CIFInvestorBeneficiaryOwnerCity }, true)[0];
                        $http({
                            method: 'GET',
                            url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.CIFInvestorBeneficiaryOwnerCity,
                            cache: true,
                        }).then(function (dataKecamatan) {
                            $scope.ListKecamatanBO = dataKecamatan.data.d;
                            if ($scope.ListKecamatanBO)
                                $scope.ListKelurahanBO = $filter('filter')($scope.ListKecamatanBO, { Kecamatan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerKecamatan }, true);
                        }, function (error) { });
                    }

                    if (data.data.d.CIFInvestorBeneficiaryOwnerCompanyCity) {
                        $scope.CompanyCityBOSelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.CIFInvestorBeneficiaryOwnerCompanyCity }, true)[0];
                        $http({
                            method: 'GET',
                            url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.CIFInvestorBeneficiaryOwnerCompanyCity,
                            cache: true,
                        }).then(function (dataKecamatan) {
                            $scope.ListKecamatanCompanyBO = dataKecamatan.data.d;
                            if ($scope.ListKecamatanCompanyBO)
                                $scope.ListKelurahanCompanyBO = $filter('filter')($scope.ListKecamatanCompanyBO, { Kecamatan: $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerCompanyAddress2 }, true);


                        }, function (error) { });
                    }

                    if ($scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource) {
                        $scope.CIFInvestorBeneficiaryOwnerFundSource = [];
                        let temp = $scope.CIFInvestor.CIFInvestorBeneficiaryOwnerFundSource.split(',');
                        for (var i = 0; i < temp.length; i++) {
                            $scope.selectedFundSourceBO.push(Number(temp[i]));
                        }
                    }

                    $scope.NationalitySelected = $filter('filter')($scope.ListNationality, { CIFCountryNID: data.data.d.CIFInvestorBeneficiaryOwnerNationality }, true)[0];

                    $scope.changeSpouseMandatory();
                    $scope.OPSPOUSE.occupation = $scope.CIFInvestor.SpouseOccupation;
                    $scope.OPSPOUSE.occupationText = $scope.CIFInvestor.SpouseOccupationText;
                    $scope.OPSPOUSE.position = $scope.CIFInvestor.SpousePosition;
                    $scope.OPSPOUSE.business = $scope.CIFInvestor.SpouseNatureOfBusiness;
                } // END IF data.data.d
            }, function (error) { });
        });

        $scope.submit = function () {
            console.log('submit');
            //setup upload data
            if ($scope.npwpPhoto)
                $scope.CIFInvestor.NPWPFile = $scope.npwpPhoto.replace("data:image/jpeg;base64,", "");

            if ($scope.othersPhoto)
                $scope.CIFInvestor.OthersFile = $scope.othersPhoto.replace("data:image/jpeg;base64,", "");

            if ($scope.parentPhoto)
                $scope.CIFInvestor.ParentFile = $scope.parentPhoto.replace("data:image/jpeg;base64,", "");

            $scope.prepareData();
            if ($scope.validation) {
                var urlsvc = '/service/client.svc/SaveCIF'; // 1
                var preconfirmtranslate = "submitCif3"; // 2
                var postData = { cifdata: $scope.CIFInvestor } // 3
                var method = "POST"; // 4
                $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {
                    if (issuccess) {

                        //if ($scope.CIFInvestor.QuestionRDN == 1) {
                        //    $http({
                        //        method: 'GET',
                        //        url: '/service/client.svc/AMLChecking?CIFNID=' + $scope.CIFInvestor.NID,
                        //    }).then(function (data) {
                        //        console.log("AMLChecking", data);
                        //        console.log("AMLChecking", data.data.d.result);

                        //    }, function (error) { });
                        //}

                        Swal.fire({
                            title: "Preparing next step...",
                            //text: "Please wait",
                            html: `Please wait <i class="far fa-xs fa-spin fa-redo-alt"></i>`,
                            icon: "info",
                            showConfirmButton: false,
                            showCancelButton: false,
                            allowOutsideClick: false,
                            didOpen: () => {
                                if ($scope.CIFInvestor.QuestionRDN == 1 || $scope.CIFInvestor.QuestionRDN == 3) {
                                    return $http({
                                        method: 'GET',
                                        url: '/service/client.svc/AMLChecking?CIFNID=' + $scope.CIFInvestor.NID,
                                    }).then(function (response) {
                                        console.log("AMLChecking", response);
                                        console.log("AMLChecking", response.data.d.result);
                                        Swal.close();
                                        $window.location.href = "#/cif/data-pernyataan";
                                    }, function (error) {
                                        console.log("Error in AMLChecking:", error);
                                        Swal.close(); // Close the Swal in case of an error too
                                    });
                                }
                                else if ($scope.CIFInvestor.QuestionRDN == 2) {
                                    return $http({
                                        method: 'GET',
                                        url: '/service/client.svc/GetRiskPermata?CIFNID=' + $scope.CIFInvestor.NID,
                                    }).then(function (response) {
                                        console.log("RiskPermata", response);
                                        console.log("RiskPermata", response.data.d.result);
                                        Swal.close();
                                        $window.location.href = "#/cif/data-pernyataan";
                                    }, function (error) {
                                        console.log("Error in RiskPermata:", error);
                                        Swal.close(); // Close the Swal in case of an error too
                                    });
                                }
                                else {
                                    Swal.close();
                                    $window.location.href = "#/cif/data-pernyataan";
                                }
                            }
                            //    timer: 10000,
                            //}).then(data => {
                            //    $window.location.href = "#/cif/data-pernyataan";
                        })
                    }

                });
            }
        }
    }]);